export default __webpack_public_path__ + "static/Megan-Bowen-1435cacf9b89b5b586892da105658c43.jpeg";